import React from 'react';
import {IPopupContainerContext} from '../@interfaces/contexts/IPopupContainerContext';

export const PopupContainerContext = React.createContext<IPopupContainerContext | null>(null);
